import styled, { css } from "styled-components";
import { ReactComponent as Crown } from "../../assets/icons/filledCrown.svg";
import { Box, Button } from "@mui/material";
import { grey } from "@mui/material/colors";

export const WeddingInvitationContainer = styled(Box)<{ $showEditPanel: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;

	[data-dispatch-id] {
		position: relative;

		&:hover {
			outline: 2px dashed ${grey[600]};
			cursor: pointer;
			border-radius: 5px;
		}

		&.active-field {
			outline: 2px dashed ${grey[600]};
			border-radius: 5px;
		}
	}

	${({ $showEditPanel }) =>
		$showEditPanel
			? css`
					margin-left: 400px;
				`
			: ""}

	.invitation-container {
		min-height: 94vh;
		position: relative;
		.invitation-wrapper {
			display: flex;
			justify-content: center;
			position: relative;
			width: 430px;
			.notification_alert {
				position: fixed;
				width: 100%;
				top: 55px;
				z-index: 100;
				max-width: 430px;
			}
			.control_notch {
				width: fit-content;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 8px;
				position: fixed;
				top: 65px;
				z-index: 10;
				padding: 8px 10px;
				border-radius: 999px;
				background: rgba(24, 24, 26, 0.55);
				backdrop-filter: blur(16px) saturate(160%);
				-webkit-backdrop-filter: blur(16px) saturate(160%);
				border: 1px solid rgba(255, 255, 255, 0.14);
				box-shadow:
					0 10px 30px rgba(0, 0, 0, 0.25),
					0 2px 8px rgba(0, 0, 0, 0.18);
				animation: control-notch-in 0.35s ease both;

				.settings_btn,
				.dashboard_btn,
				.share_btn,
				.plan_btn {
					display: flex;
					justify-content: center;
					align-items: center;
				}

				button {
					width: 40px;
					height: 40px;
					background: rgba(255, 255, 255, 0.12);
					color: #ffffff;
					transition:
						background 0.2s ease,
						transform 0.2s ease,
						box-shadow 0.2s ease;

					svg {
						font-size: 20px;
					}

					&:hover {
						background: rgba(255, 255, 255, 0.26);
						transform: translateY(-2px);
					}

					&:active {
						transform: translateY(0);
					}
				}

				.plan_btn {
					svg {
						width: 20px;
						height: 20px;
					}

					button {
						background: linear-gradient(135deg, #f5d67c, #c9a84c);
						box-shadow: 0 4px 14px rgba(201, 168, 76, 0.45);
						cursor: unset;

						svg path,
						svg polygon {
							fill: #5a4413;
						}

						&:hover {
							background: linear-gradient(135deg, #f5d67c, #c9a84c);
							transform: none;
						}
					}
				}

				.progress {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 48px;
					height: 48px;
					background: #fff;
					border-radius: 50%;
					cursor: pointer;
					box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
					transition:
						transform 0.2s ease,
						box-shadow 0.2s ease;

					&:hover {
						transform: translateY(-2px) scale(1.05);
						box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);
					}
				}
			}

			@keyframes control-notch-in {
				from {
					opacity: 0;
					transform: translateY(-8px);
				}
				to {
					opacity: 1;
					transform: translateY(0);
				}
			}

			.guide_welcome {
				position: absolute;
				height: 20px;
				width: 20px;
				top: 30vh;
				left: 0;
				right: 0;
				margin-right: auto;
				margin-left: auto;
			}
			.add_story {
				width: 100%;
				height: 24px;
				padding: 2px;
				border: 2px dashed #757575;
				border-radius: 5px;
				cursor: pointer;
				display: flex;
				justify-content: center;
			}
		}
		.edit_panel_save_btn_wrapper {
			position: sticky;
			bottom: 0;
		}
		.save-btn-wrapper {
			position: sticky;
			bottom: 15px;
		}
	}

	${props => props.theme.breakpoints.down("sm")} {
		.invitation-container {
			width: 100%;
			.invitation-wrapper {
				width: 100%;
			}
		}
		.invitation-buy-button {
			width: 100%;
		}
	}
`;

export const EditFormWrapper = styled(Box)`
	position: fixed;
	width: 450px;
	left: 0;
	height: 94vh;
	background: ${grey[100]};
`;

export const UpgradeBtn = styled(Button)`
	background: #c9a84c;
	color: #fff;
	font-weight: bold;
`;
export const GoldCrown = styled(Crown)`
	width: 18px;
	height: 20px;

	path,
	polygon {
		fill: #c9a84c;
	}
`;
export const WhiteCrown = styled(Crown)`
	width: 18px;
	height: 20px;

	path,
	polygon {
		fill: #fff;
	}
`;
export const BlackCrown = styled(Crown)`
	width: 18px;
	height: 20px;

	path,
	polygon {
		fill: #000;
	}
`;

export const PlanBadge = styled(Box)<{ $signature?: boolean }>`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 13px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.6px;
	color: ${({ $signature }) => ($signature ? "#8B6914" : "#557189")};
	background: ${({ $signature }) => ($signature ? "#FDF3D0" : "#E8F2FA")};
	border-radius: 20px;
	padding: 4px 12px;
	margin-bottom: 16px;
	width: fit-content;
`;
